"use strict";

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey2(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey2(t) { var i = _toPrimitive2(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive2(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.VisitsData = void 0;
var _utilities = require("../utilities"),
  _types = require("../utilities/types"),
  _types2 = require("./types"),
  _types3 = require("../types");
function _defineProperty(a, b, c) {
  return (b = _toPropertyKey(b)) in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
}
function _toPropertyKey(a) {
  var b = _toPrimitive(a, "string");
  return "symbol" == _typeof(b) ? b : b + "";
}
function _toPrimitive(a, b) {
  if ("object" != _typeof(a) || !a) return a;
  var c = a[Symbol.toPrimitive];
  if (void 0 !== c) {
    var d = c.call(a, b || "default");
    if ("object" != _typeof(d)) return d;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === b ? String : Number)(a);
}
var VisitsData = /*#__PURE__*/function () {
  function VisitsData(a) {
    _classCallCheck(this, VisitsData);
    _defineProperty(this, "visits", void 0), _defineProperty(this, "status", _types3.TrackingStatus.Sent), this.visits = a;
  }
  return _createClass(VisitsData, [{
    key: "url",
    get: function get() {
      return "";
    }
  }, {
    key: "data",
    get: function get() {
      return {
        visits: this.visits,
        type: _types2.KameleoonData.VisitsData,
        status: this.status
      };
    }
  }, {
    key: "isSent",
    get: function get() {
      return !0;
    }
  }, {
    key: "timestamp",
    set: function set(a) {
      _utilities.Utilities.insertInOrderedListMutably({
        list: this.visits,
        element: a,
        order: _types.Order.Ascending
      }), this.visits = _toConsumableArray(new Set(this.visits));
    }
  }]);
}();
exports.VisitsData = VisitsData;